import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import HttpService from '../services/httpService';
import { ROLENAME } from '../utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { commaSeparateAmount } from './commaSeparate';
import { Typography } from 'antd';
import Autocomplete from '@material-ui/lab/Autocomplete';
const useStyles = makeStyles((theme) => ({
    table: {
        width: '80vw',
        textAlign: 'center'
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));
const LeadApprovalView = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();
    const [designerAssignment, setDesignerAssignment] = useState([]);
    const [openRemarkModal, setOpenRemarkModal] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0)
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])

    const [data, setData] = useState({
        grandTotal: "",
        paymentDone: ""
    })

    const { grandTotal, paymentDone } = data
    const changeHandler = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        getAllApprovedLeads();
        getAmountReceivedForLead();
        expCenters();
        // eslint-disable-next-line
    }, [])

    const getAllApprovedLeads = async (selectedExpCenter) => {
        props.setLoading(true)
        let expCenterData = selectedExpCenter?.map((el) => el._id)
        try {
            let expCenterId = expCenterData?.length > 0 ? expCenterData : userDetails.selectedExpCenter
            const response = await HttpService.getApprovedLeadLists(expCenterId)
            response.data.forEach(lead => {
                getAmountReceivedForLead(lead._id);
            });
            setDesignerAssignment(response.data);
        } catch (error) {
            setDesignerAssignment([]);
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [remark, setRemark] = useState("");
    const [actionStatus, setActionStatus] = useState("");
    const [selectedLeadId, setSelectedLeadId] = useState("");
    const [selectedLead, setSelectedLead] = useState([]);
    const [salesUserEmail, setSalesUserEmail] = useState("")
    const openModalAction = async (status, lead) => {
        setActionStatus(status)
        setOpenRemarkModal(true);
        if (status === 'approve') {
            const { grandTotal, paymentDone } = lead
            setData({ grandTotal, paymentDone })
        }
        setSelectedLead(lead);
        setSelectedLeadId(lead._id);
        let salesUser = [];
        for (let i = 0; i < lead.previouslyAssignedTo.length; i++) {
            for (let j = 0; j < lead.previouslyAssignedTo[i].roles.length; j++) {
                if (lead.previouslyAssignedTo[i]['roles'][j].name === 'Sales User') {
                    salesUser.push(lead.previouslyAssignedTo[i])
                }
            }
        }
        if (salesUser.length !== 0) {
            let finalSalesUser = salesUser.pop();
            setSalesUserEmail(finalSalesUser.email)
        } else {
            setSalesUserEmail(lead.assignTo.email)
        }
    }

    const [fileUploaded, setFileUploaded] = useState(false);

    const handleMultipleExpData = (event, newValue) => {
        setSelectedExperienceCenter(newValue)
        getAllApprovedLeads(newValue)
    }

    const onImageChange = async (e) => {
        props.setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        fd.append('customerName', selectedLead.lead_no + '_' + selectedLead.customerId.name)
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setData({
                ...data,
                paymentProofAtachement: fileUploadRes.data
            })
            setFileUploaded(true);
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const getAmountReceivedForLead = async (leadId) => {
        try {
            let obj = {};
            obj.leadId = leadId;
            
            // Fetch payment transactions for the lead
            const result = await HttpService.getApprovedPaymentTransactionsForLead(obj);
    
            // Calculate total amount received
            const totalAmountReceived = result.data
                .filter(obj => obj.Status === 'Payment Received' && obj.hasOwnProperty('Amount_Received'))
                .reduce((sum, obj) => sum + obj['Amount_Received'], 0);
            setTotalAmount(totalAmountReceived)
            // Update the state with the total amount received for the specific lead
            setDesignerAssignment(prevState => 
                prevState.map(lead => 
                    lead._id === leadId ? { ...lead, totalAmountReceived } : lead
                )
            );
        } catch (error) {
            console.log(error, "err");
        }
    };

    const updateDesignManagerToLead = async () => {
        setOpenRemarkModal(false);
        let obj = {};
        if (actionStatus === 'approve') {
            if (userDetails.roles.find(role => role.name === ROLENAME.FinanceManager)) {
                if (selectedLead.reinitiateProcess === 'Send for Approval') {
                    obj = {
                        takenAction: 'approved',
                        reinitiateProcess: "approved",
                        // financeManagerApproved: [{
                        //     isApproved: true,
                        //     status: 'Approved',
                        //     remark: remark,
                        //     approvedBy: userDetails._id
                        // }],
                        // customerApproved: [{
                        //     isApproved: false,
                        //     status: 'Send for Approval'
                        // }],
                    }
                } 
            } else if (userDetails.roles.find(role => role.name === ROLENAME.Admin)) {
                obj = {
                    takenAction: 'approved',
                    businessHeadApproved: [{
                        isApproved: true,
                        status: 'Approved',
                        remark: remark,
                        approvedBy: userDetails._id
                    }],
                    approvedRemarks: remark,
                    checkListUrgentRequest: [
                        {
                            sent: false,
                            action: "Approved",
                        }
                    ],
                    customerApproved: [{
                        isApproved: false,
                        status: 'Send for Approval'
                    }],
                    //salesStage: 'Won',
                    //leadStatus: "Won",
                    approvalDone: true,
                    salesUserEmail: salesUserEmail,
                    remark: remark,

                }
            }
        } else {
            if (userDetails.roles.find(role => role.name === ROLENAME.FinanceManager)) {
                obj = {
                    takenAction: 'rejected',
                    salesStage: 'Won Deals Pending Designer Assignment',
                    currentStage: 'Won Deals Pending Designer Assignment',
                    salesExecutiveApproved: [{ isApproved: false, status: 'Send for Approval' }],
                    salesManagerApproved: [{ isApproved: false, status: 'Approval Not Initiated' }],
                    customerApproved: [{ isApproved: false, status: 'Approval Not Initiated' }],
                    "checkListUrgentRequest.sent": false,
                    "checkListUrgentRequest.action": "Rejected",
                    // financeManagerApproved: [{
                    //     isApproved: false,
                    //     status: 'Rejected',
                    //     remark: remark
                    // }],
                    centerHeadApproved: [{ isApproved: false, status: 'Approval Not Initiated' }],
                    salesLeadOwnRole: "NA"
                }
            } else if (userDetails.roles.find(role => role.name === ROLENAME.Admin)) {
                obj = {
                    takenAction: 'rejected',
                    rejectedRemarks: remark,
                    checkListUrgentRequest: [{ sent: false, action: 'Rejected' }],
                }

            }
        }
        // console.log(selectedLeadId, obj)
        props.setLoading(true)
        try {
            const response = await HttpService.salesManagersApprovedLead(selectedLeadId, obj);
            history.push('/lead-approval');
            getAllApprovedLeads()
            props.setSnackInfo(response?.data ?? "Updated Successfully", "success")
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const navigateToCheckList = (data) => {
        history.push({
            pathname: '/check-lists',
            state: {
                actionCheck: 'yes',
                leadId: data._id,
                customerDetail: data.customerId,
            }
        })
    }

    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <h3 style={{ textAlign: 'center' }}>
                    {userDetails.roles.find(role => role.name === ROLENAME.SalesManager) && `Sales Manager Lead Approval`}
                    {userDetails.roles.find(role => role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesHead) && `DGM Sales Lead Approval`}
                    {userDetails.roles.find(role => role.name === ROLENAME.CenterHead) && `Center Head Approval`}
                    {userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) && `Finance Manager Lead Approval`}
                    {userDetails.roles.find(role => role.name === ROLENAME.BusinessHead) && `Business Head Approval`}
                </h3>
            </div>
            <Divider />
            {userDetails?.roles && userDetails.roles.some(role => [ ROLENAME.DGM_Sales, ROLENAME.SalesHead].includes(role.name)) && (
                <div style={{ display: 'flex' }}>
                    <FormControl style={{ width: '30%', marginTop: '0.4rem' }}>
                        <Autocomplete
                            multiple
                            value={selectedExperienceCenter}
                            onChange={handleMultipleExpData}
                            options={commonExpCenter}
                            getOptionLabel={(option) => option.name}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Exp-Center"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </div>
            )}

            <div style={{ display: 'flex', marginTop: 10, marginBottom: 20 }}>
                <Paper>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sl No.</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead Name</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Lead No.</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Quotation Value</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Token Received</TableCell>
                                     <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Urgent Remarks</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sales Executive</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Action</TableCell>



                                    {/* {userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) &&
                                        <TableCell>Customer Email Id</TableCell>
                                    } */}
                                    {/* {userDetails.roles.find(role => role.name === ROLENAME.BusinessHead || role.name === ROLENAME.FinanceManager ) ?
                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Assigned To</TableCell>
                                        :
                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Sales Executive</TableCell>
                                    } */}
                                    {userDetails.roles.find(role => role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager) && (
                                        <>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>View Details</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Remarks</TableCell>
                                                                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Remarks</TableCell>

                                        </>
                                    )}
                                    {userDetails.roles.find(role => role.name === ROLENAME.CenterHead) &&
                                        <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}} component="th">Payment Percentage</TableCell>
                                    }
                                    {userDetails.roles.find(role => role.name === ROLENAME.BusinessHead || role.name === ROLENAME.FinanceManager) && (
                                        <>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Quotation Value</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Quotation Amount Paid</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Proof (Attachment)</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>Token %</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}}>B2B GST Invoice</TableCell>
                                            <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold'}} colSpan={2}>Action</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {designerAssignment.length !== 0 ?
                                    designerAssignment.sort((a, b) => b.createdAt.split('-').reverse().join().localeCompare(a.createdAt.split('-').reverse().join())).map((row, i) => {
                                        return (
                                            <TableRow key={i + 1}>
                                                <TableCell>{i + 1}</TableCell>
                                                <TableCell component="th" scope="row"> {row?.customerId?.name} </TableCell>
                                                <TableCell component="th"> {row?.lead_no}</TableCell>
                                                 <TableCell component="th">₹ {commaSeparateAmount(row?.grandTotal)}</TableCell>
                                                <TableCell component="th">₹ {commaSeparateAmount(row?.totalAmountReceived)}</TableCell>
                                                <TableCell component="th"> {row?.checkListUrgentRequest[0]?.remarks}</TableCell>
                                                <TableCell component="th">{row?.assignTo?.name}</TableCell>
                                                <TableCell component="th">
                                                            <Button color="primary" variant="contained" onClick={() => openModalAction('approve', row)}
                                                                disabled={
                                                                    (userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) ) ||
                                                                    (userDetails.roles.find(role => role.name === ROLENAME.BusinessHead) &&
                                                                        row.businessHeadApproved.find((ele1, i) => ele1.status === 'Approved'))
                                                                }
                                                                style={{ marginRight: 5 }}>
                                                                Approve
                                                            </Button>
                                                            <Button color="secondary" variant="outlined" onClick={() => openModalAction('reject', row)}
                                                                disabled={
                                                                    (userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) ) ||
                                                                    (userDetails.roles.find(role => role.name === ROLENAME.BusinessHead) &&
                                                                        row.businessHeadApproved.find((ele1, i) => ele1.status === 'Approved' || ele1.status === 'Approval Not Initiated'))
                                                                } >
                                                                Reject
                                                            </Button>
                                                        </TableCell>
                                                {/* {userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) &&
                                                    <TableCell>{row?.customerId?.email}</TableCell>
                                                } */}
                                                {userDetails.roles.find(role => role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.AGMSales) && (
                                                    <>
                                                        <TableCell component="th">
                                                            <Button
                                                                disabled={
                                                                    userDetails.roles.find(role => role.name === ROLENAME.CenterHead) &&
                                                                    (row.salesManagerApproved.find((ele1) => ele1.status !== 'Approved' || ele1.isApproved === false))
                                                                }
                                                                onClick={() => navigateToCheckList(row)} color="primary" variant='outlined'>
                                                                View Details
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell component="th">{row?.remark? row?.remark: "NA"}</TableCell>
                                                    </>
                                                )}
                                                {userDetails.roles.find(role => role.name === ROLENAME.CenterHead) &&
                                                    <TableCell component="th">{((row?.totalAmountReceived / row?.grandTotal) * 100).toFixed(2)} %</TableCell>
                                                }
                                                {userDetails.roles.find(role => role.name === ROLENAME.BusinessHead || role.name === ROLENAME.FinanceManager ) && (
                                                    <>
                                                        <TableCell component="th">₹ {commaSeparateAmount(row?.grandTotal)}</TableCell>
                                                        <TableCell component="th">₹ {commaSeparateAmount(row?.totalAmountReceived)}</TableCell>
                                                        <TableCell component="th">
                                                            <Button color="primary" variant="outlined" disabled={!row?.salesPaymentProofAtachement || row?.salesPaymentProofAtachement === 'NA'} onClick={() => window.open(row?.salesPaymentProofAtachement)}>Download</Button>
                                                        </TableCell>
                                                        <TableCell component="th">{row?.tokenPercent}</TableCell>
                                                        <TableCell component="th" style={{ width: 100 }}>
                                                            {row?.customerRequriedGst ?
                                                                    <>
                                                                            <Typography>{row?.customerGstInName}</Typography>
                                                                            <Typography>{row?.customerGstInNumber}</Typography>
                                                                            <Typography>{row?.customerGstShipping}</Typography>
                                                                    </> : <Typography>NA</Typography>}
                                                                </TableCell>
                                                    
                                                    </>
                                                )}
                                            </TableRow>
                                        );
                                    })
                                    :
                                    <TableRow>
                                        <TableCell colSpan={9} style={{ textAlign: 'center' }}>No Records Found</TableCell>
                                    </TableRow>
                                }
                            </TableBody>

                        </Table>
                    </TableContainer>
                </Paper>
            </div>

            <Dialog open={openRemarkModal} onClose={() => setOpenRemarkModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    Enter Remark
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15 }}>
                        <FormControl fullWidth >
                            <TextField
                                id="outlined-multiline-static"
                                label="Enter Narration"
                                multiline
                                rows={4}
                                onChange={(e) => setRemark(e.target.value)}
                                name="remark"
                                variant="outlined"
                                className={classes.textFieldWidth}
                            />
                        </FormControl>
                        {/* {(userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) && actionStatus === 'approve') &&
                            <div style={{ marginBottom: 20 }}>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="Quotation Value" value={grandTotal} variant="outlined" name="grandTotal" onChange={changeHandler} disabled />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="Amount Paid" value={paymentDone} variant="outlined" name="paymentDone" onChange={changeHandler} />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="Token %" value={((paymentDone / grandTotal) * 100).toFixed(2)} variant="outlined" name="tokenPercent" onChange={changeHandler} />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="Account Name" variant="outlined" name="accountName" onChange={changeHandler} />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="Account Through" variant="outlined" name="accountThrough" onChange={changeHandler} />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10 }}>
                                    <TextField id="outlined-basic" label="On Account Of" variant="outlined" name="onAccountOf" onChange={changeHandler} />
                                </FormControl>
                                <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                    {
                                        userDetails.roles.find(role => role.name === ROLENAME.FinanceManager) && <>
                                            <input
                                                accept="image/*"
                                                className={classes.input}
                                                id="contained-button-file"
                                                multiple
                                                type="file"
                                                onChange={onImageChange}
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor="contained-button-file">
                                                <Button variant="contained" color="primary" disabled={userDetails.roles.find(role => role.name === ROLENAME.SalesManager)} component="span" startIcon={<CloudUploadIcon />}>
                                                    Upload Payment Proof
                                                </Button>
                                                {
                                                    fileUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                                                }
                                            </label>
                                        </>
                                    }
                                </FormControl>
                            </div>
                        } */}
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenRemarkModal(false)} color="secondary" variant='outlined'>
                        Cancel
                    </Button>
                    <Button onClick={() => updateDesignManagerToLead()} color="primary" variant='contained'>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(LeadApprovalView)
